// extracted by mini-css-extract-plugin
module.exports = {"btnImgUrlSize":"verifyemailform_btnImgUrlSize__3UCnq","btnImgUrlText":"verifyemailform_btnImgUrlText__2dDgn"};